/* import __COLOCATED_TEMPLATE__ from './attribute-spend-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();